<template>
  <CallButton
    v-if="view == null"
    disabled
    :tooltip-message="tooltipMessage"
  />
  <component
    :is="view"
    v-else
    :phone-number="phoneNumber"
    :disabled="disabled"
    @click="handleClick"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { CallTargetSfSyncSettingInfo } from '@/api/openapi';
import useCallResultActionState from '@/composable/user/callResult/call-result-action-state';
import { useActiveCti } from '@/composable/user/lead/active-cti';
import { key } from '@/store/index';
import CallButton from './CallButton.vue';
import MiitelCallButton from './MiitelCallButton.vue';
import ZoomPhoneCallButton from './ZoomPhoneCallButton.vue';

type TProps = {
  phoneNumber: string;
  disabled?: boolean;
  callResultNextActionId?: number;
  phoneNumberKey?: string;
  sfSyncSettingInfo: object;
};
const props = defineProps<TProps>();

const i18n = useI18n();
const store = useStore(key);
const { activeCti } = useActiveCti(true);
const { canCreateCallResult } = useCallResultActionState(() => props.sfSyncSettingInfo as CallTargetSfSyncSettingInfo);

const tooltipMessage = computed(() => {
  if (!canCreateCallResult.value) return i18n.t('callTarget.errors.salesforceUnableToLinkUser.title');
  return i18n.t('cti.settingsRequired');
});

const view = computed(() => {
  if (!canCreateCallResult.value) return null;
  if (activeCti.value === 'miitel') return MiitelCallButton;
  if (activeCti.value === 'zoom') return ZoomPhoneCallButton;
  return null;
});

const handleClick = () => {
  store.dispatch('userUi/setTargetCallResultFormLogValuesAction', {
    nextActionId: props.callResultNextActionId,
    phoneNumberKey: props.phoneNumberKey,
  });
};
</script>
